import { cn } from '../../lib/utils'

interface LongyLogoProps {
    className?: string
}

export const LongyLogo = ({ className }: LongyLogoProps) => {
    return (
        <img
            className={cn('h-full w-auto object-contain', className)}
            src="/icon.svg"
            alt="Long-Y"
        />
    )
}
